import { Icon, IconProps } from '@chakra-ui/icons'
import { FC } from 'react'

export const BadgeCheck: FC<IconProps> = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      width="36px"
      height="36px"
      fill="none"
      color="#F6F4E8"
      {...props}
    >
      <path
        fill="currentColor"
        d="m16.219 19.694-2.834-2.902c-.268-.288-.6-.431-.993-.431s-.738.139-1.034.417c-.287.287-.43.63-.43 1.027 0 .399.143.741.43 1.028l3.888 3.861c.278.278.602.417.973.417.37 0 .694-.139.972-.417l7.444-7.416a1.34 1.34 0 0 0 .41-1 1.367 1.367 0 0 0-.437-1 1.38 1.38 0 0 0-.993-.382 1.335 1.335 0 0 0-.966.396l-6.43 6.402Zm-4.473 14.723L9.22 30.11l-4.972-1.028a1.337 1.337 0 0 1-.848-.548c-.222-.301-.305-.623-.25-.966l.542-4.902-3.236-3.75A1.272 1.272 0 0 1 .094 18c0-.361.12-.667.36-.917l3.237-3.722-.542-4.903c-.055-.342.028-.664.25-.965.223-.301.505-.484.848-.549l4.972-1.027 2.527-4.334c.186-.305.445-.516.778-.632.334-.115.667-.1 1 .049l4.473 2.028L22.469 1a1.364 1.364 0 0 1 1-.063c.333.107.592.313.777.618l2.556 4.362 4.945 1.027c.342.065.624.248.847.549.222.3.305.623.25.965l-.542 4.903 3.236 3.722c.241.25.361.556.361.917s-.12.667-.36.917l-3.237 3.75.542 4.902c.055.343-.028.665-.25.966-.223.3-.505.483-.848.548l-4.944 1.028-2.555 4.333a1.373 1.373 0 0 1-.778.618 1.364 1.364 0 0 1-1-.062l-4.473-2.028L13.524 35a1.317 1.317 0 0 1-1 .048 1.436 1.436 0 0 1-.777-.631Zm1.862-2.528 4.389-1.861 4.5 1.86 2.639-4.11 4.777-1.195-.472-4.86L32.719 18l-3.278-3.806.472-4.86-4.777-1.112-2.723-4.111-4.416 1.861-4.5-1.861-2.64 4.111L6.08 9.333l.472 4.861L3.274 18l3.278 3.722-.472 4.945 4.778 1.11 2.75 4.112Z"
      />
    </Icon>
  )
}
